<template>
  <main>
    <!-- <v-data-table :headers="headers" :items="camps" hide-default-footer></v-data-table> -->
    <InputFilter
      class="pt-10"
      hint="Start with (*) in case you search with id"
      :pagination="pagination"
    />

    <v-container>
      <v-toolbar flat class="main-header mb-12">
        <v-toolbar-title class="main-header__title">
          <h1>All Children</h1>
        </v-toolbar-title>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="children"
        :loading="loadingChildren"
        :mobile-breakpoint="zero"
        :items-per-page="20"
        class="table"
        hide-default-footer
      >
        <!-- hide-default-footer -->
        <template v-slot:item="{ item, index }">
          <tr class="table__row">
            <td class="table__cell text-center">
              <v-avatar size="50">
                <v-img
                  v-if="item.photo_url != null"
                  :src="item ? item.photo_url : '--'"
                ></v-img>
                <span v-else>No Photo</span>
              </v-avatar>
            </td>
            <td class="table__cell text-center">{{ item.account_no }}</td>
            <td class="table__cell text-center">{{ item.wellspring_id }}</td>
            <td class="table__cell text-center name">{{ item.full_name }}</td>
            <td class="table__cell text-center">
              {{ item.parent ? item.parent.name : "---" }}
            </td>
            <td class="table__cell text-center">
              {{ item.parent ? item.parent.mobile : "---" }}
            </td>
            <!-- <td class="table__cell text-center name">
              {{ item.card_invoice_no || "---" }}
            </td> -->
            <td class="table__cell text-center">
              <i
                v-if="item.is_reg_fees_paid == '1'"
                class="icon-active blue-coloring"
              ></i>
              <v-icon v-else>mdi-checkbox-blank-circle-outline</v-icon>
            </td>
            <td class="table__cell text-center">
              <i
                v-if="item.card_issued == '1'"
                class="icon-active blue-coloring"
              ></i>
              <v-icon v-else>mdi-checkbox-blank-circle-outline</v-icon>
            </td>
            <td class="table__cell text-center">
              <i
                v-if="item.is_insured == '1'"
                class="icon-active blue-coloring"
              ></i>
              <v-icon v-else>mdi-checkbox-blank-circle-outline</v-icon>
            </td>
            <td class="table__cell text-center">
              <span class="hovering mr-1 edit">
                <router-link
                  :to="`/accounts/children/create/${item.id}`"
                  v-if="
                    permissions.includes(
                      'update_api_admin-panel_children_{child}'
                    )
                  "
                >
                  <v-icon small>mdi-pencil</v-icon><br />
                  Edit
                </router-link>
              </span>
              <span
                v-if="
                  permissions.includes(
                    'destroy_api_admin-panel_children_{child}'
                  )
                "
                class="hovering delete"
                @click="handleDelete(item, index)"
              >
                <v-icon small>mdi-delete</v-icon><br />
                Delete
              </span>
            </td>
          </tr>
        </template>
      </v-data-table>
      <!-- pagination -->
      <div class="text-xs-center pt-2">
        <v-pagination
          v-if="children.length > 0 && pagination.last_page > 1"
          v-model="pagination.current_page"
          :length="pagination.last_page"
          :total-visible="20"
          @input="handlePagination"
        ></v-pagination>
      </div>
      <!-- pagination -->
    </v-container>
  </main>
</template>

<script>
import { IndexData, DeleteData } from "@/helpers/apiMethods";
import TableHeaders from "@/helpers/TableHeaders";
import { isEqual } from "lodash";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      zero: 0,
      headers: [],
      children: [],
      pagination: {},
      queries: {},
      search: null,
      loadingChildren: false
    };
  },
  components: {
    InputFilter: () => import("./../components/InputFilter")
  },
  computed: {
    ...mapGetters({
      permissions: "permissions"
    })
  },
  created() {
    this.indexchildren();
    this.childrenHeaders();
  },
  methods: {
    indexchildren(query) {
      this.loadingChildren = true;
      IndexData({ reqName: "children", query })
        .then(res => {
          const { data, meta } = res.data;
          this.children = data;
          this.loadingChildren = false;
          this.pagination = meta;
        })
        .catch(() => {})
        .finally(() => {});
    },
    childrenHeaders() {
      const headersList = [
        "Photo",
        "Account No",
        "Wellspring Id",
        "Name",
        "Parent",
        "Mobile",
        // "Invoice No",
        "Paid",
        "Issued",
        "Insured",
        "Actions"
      ];
      this.headers = TableHeaders(headersList);
    },
    createCamp() {
      this.$route.push("/children/create");
    },
    handlePagination(page) {
      this.queries = { ...this.queries, page };
      if (!isEqual(this.queries, this.$route.query)) {
        this.$router.push({ query: this.queries });
      }
    },
    handleDelete({ id }, index) {
      this.popUp().then(value => {
        if (!value.dismiss) {
          DeleteData({
            reqName: `/children`,
            id: id
          })
            .then(() => {
              // this.$delete(this.children, index);
              this.children.splice(index, 1);
            })
            .catch(() => {});
        }
      });
    }
  },
  watch: {
    $route: {
      handler({ query }) {
        this.queries = query;
        this.indexchildren(this.queries);
      },
      immediate: true
    }
  }
};
</script>
